import ArrowDownIcon from "@/assets/icons_svg/ArrowDownIcon.vue";
import ArrowDownFilledIcon from "@/assets/icons_svg/ArrowDownFilledIcon.vue";
import ArrowLeftIcon from "@/assets/icons_svg/ArrowLeftIcon.vue";
import ArrowRightIcon from "@/assets/icons_svg/ArrowRightIcon.vue";
import ArrowUpIcon from "@/assets/icons_svg/ArrowUpIcon.vue";
import AtendimentosIcon from "@/assets/icons_svg/AtendimentosIcon.vue";
import BacteriaIcon from "@/assets/icons_svg/BacteriaIcon.vue";
import ClipboardPulseIcon from "@/assets/icons_svg/ClipboardPulseIcon.vue";
import CidadaoIcon from "@/assets/icons_svg/CidadaoIcon.vue";
import ExitIcon from "@/assets/icons_svg/ExitIcon.vue";
import FileDocumentMultipleIcon from "@/assets/icons_svg/FileDocumentMultipleIcon.vue";
import FiltrosIcon from "@/assets/icons_svg/FiltrosIcon.vue";
import FullscreenDefaultIcon from "@/assets/icons_svg/FullScreenDefaultIcon.vue";
import FullscreenExitIcon from "@/assets/icons_svg/FullScreenExitIcon.vue";
import HamburguerIcon from "@/assets/icons_svg/HamburguerIcon.vue";
import LeitoIcon from "@/assets/icons_svg/LeitoIcon.vue";
import ListBulletedIcon from "@/assets/icons_svg/ListBulletedIcon.vue";
import PacienteIcon from "@/assets/icons_svg/PacienteIcon.vue";
import PainelIcon from "@/assets/icons_svg/PainelIcon.vue";
import PillIcon from "@/assets/icons_svg/PillIcon.vue";
import PlanoCuidadoIcon from "@/assets/icons_svg/PlanoCuidadoIcon.vue";
import ProfSaudeIcon from "@/assets/icons_svg/ProfSaudeIcon.vue";
import SearchIcon from "@/assets/icons_svg/SearchIcon.vue";
import UnidadeSaudeIcon from "@/assets/icons_svg/UnidadeSaudeIcon.vue";
import UsuarioIcon from "@/assets/icons_svg/AccountCircleIcon.vue";
import DeleteIcon from "@/assets/icons_svg/DeleteIcon.vue";
import EditIcon from "@/assets/icons_svg/BorderColorIcon.vue";
import EditPassword from "@/assets/icons_svg/AccountKeyIcon.vue";
import DisableIcon from "@/assets/icons_svg/AccountOffIcon.vue";
import EnableIcon from "@/assets/icons_svg/AccountCheckIcon.vue";
import ProfileIcon from "@/assets/icons_svg/ClipboardPlusIcon.vue";
import NotificationIcon from "@/assets/icons_svg/NotificationIcon.vue";
import InformationIcon from "@/assets/icons_svg/InformationOutlineIcon.vue";
import ProcedimentoIcon from "@/assets/icons_svg/PrescricaoProcedimentoMinIcon.vue";
import MedicamentoIcon from "@/assets/icons_svg/PrescricaoMedicamentoMinIcon.vue";
import DietaIcon from "@/assets/icons_svg/PrescricaoDietaIcon.vue";
import CuidadoIcon from "@/assets/icons_svg/PrescricaoCuidadoMinIcon.vue";
import AuditIcon from "@/assets/icons_svg/TextBoxSearchIcon.vue";
import ExportIcon from "@/assets/icons_svg/CloudDownloadIcon.vue";
import AcolhimentoIcon from "@/assets/icons_svg/HandHeartIcon.vue";
import RoleIcon from "@/assets/icons_svg/AccountCogIcon.vue";
import AnalyticsIcon from "@/assets/icons_svg/AnalyticsIcon.vue";
import CalendarAsc from "@/assets/icons_svg/SortCalendarAscendingIcon.vue";
import CalendarDesc from "@/assets/icons_svg/SortCalendarDescendingIcon.vue";
import ThemeIcon from "@/assets/icons_svg/ThemeIcon.vue";
import ParamsIcon from "@/assets/icons_svg/ParamsIcon.vue";
import NaturezaIcon from "@/assets/icons_svg/TabPlusIcon.vue";
import NotificacaoEventoIcon from "@/assets/icons_svg/ListBoxIcon.vue";
import SpreadSheetIcon from "@/assets/icons_svg/SpreadSheetIcon.vue";
import DownloadIcon from "@/assets/icons_svg/DownloadIcon.vue";
import SegmentationIcon from "@/assets/icons_svg/SegmentationIcon.vue";
import OpenInNewTabIcon from "@/assets/icons_svg/OpenInNewTabIcon.vue";
import EmailIcon from "@/assets/icons_svg/EmailIcon.vue";
import ApiIcon from "@/assets/icons_svg/ApiIcon.vue";
import PlusIcon from "@/assets/icons_svg/PlusIcon.vue";
import TeamsIcon from "@/assets/icons_svg/TeamsIcon.vue";
import SickIcon from "@/assets/icons_svg/SickIcon.vue";
import AnalyzeIcon from "@/assets/icons_svg/AnalyzeIcon.vue";
import ClinicIcon from "@/assets/icons_svg/ClinicIcon.vue";
import ClockIcon from "@/assets/icons_svg/ClockIcon.vue";
import ConnectedPeopleIcon from "@/assets/icons_svg/ConnectedPeopleIcon.vue";
import ControlPanelIcon from "@/assets/icons_svg/ControlPanelIcon.vue";
import DashboardIcon from "@/assets/icons_svg/DashboardIcon.vue";
import DoctorFemaleIcon from "@/assets/icons_svg/DoctorFemaleIcon.vue";
import DoctorMaleIcon from "@/assets/icons_svg/DoctorMaleIcon.vue";
import HospitalBedIcon from "@/assets/icons_svg/HospitalBedIcon.vue";
import HospitalIcon from "@/assets/icons_svg/HospitalIcon.vue";
import HospitalRoomIcon from "@/assets/icons_svg/HospitalRoomIcon.vue";
import MaleFemaleUserGroupIcon from "@/assets/icons_svg/MaleFemaleUserGroupIcon.vue";
import MemberIcon from "@/assets/icons_svg/MemberIcon.vue";
import OldWomanIcon from "@/assets/icons_svg/OldWomanIcon.vue";
import PeopleIcon from "@/assets/icons_svg/PeopleIcon.vue";
import PlannerIcon from "@/assets/icons_svg/PlannerIcon.vue";
import ScheduleIcon from "@/assets/icons_svg/ScheduleIcon.vue";
import SeniorCitizenIcon from "@/assets/icons_svg/SeniorCitizenIcon.vue";
import TearOffCalendarIcon from "@/assets/icons_svg/TearOffCalendarIcon.vue";
import UserGroupsIcon from "@/assets/icons_svg/UserGroupsIcon.vue";
import UserMaleIcon from "@/assets/icons_svg/UserMaleIcon.vue";
import ThreePeopleIcon from "../assets/icons_svg/ThreePeopleIcon.vue";
import FatherIcon from "@/assets/icons_svg/FatherIcon.vue";
import EnfermeiraIcon from "@/assets/icons_svg/EnfermeiraIcon.vue";
import TelessaudeIcon from "@/assets/icons_svg/TelessaudeIcon.vue";
import SoliciTelessaudeIcon from "@/assets/icons_svg/SoliciTelessaudeIcon.vue";

export default [
  { name: "ArrowDownIcon", component: ArrowDownIcon },
  { name: "ArrowDownFilledIcon", component: ArrowDownFilledIcon },
  { name: "ArrowLeftIcon", component: ArrowLeftIcon },
  { name: "ArrowRightIcon", component: ArrowRightIcon },
  { name: "ArrowUpIcon", component: ArrowUpIcon },
  { name: "AtendimentosIcon", component: AtendimentosIcon },
  { name: "BacteriaIcon", component: BacteriaIcon },
  { name: "ClipboardPulseIcon", component: ClipboardPulseIcon },
  { name: "CidadaoIcon", component: CidadaoIcon },
  { name: "ExitIcon", component: ExitIcon },
  { name: "FileDocumentMultipleIcon", component: FileDocumentMultipleIcon },
  { name: "FiltrosIcon", component: FiltrosIcon },
  { name: "FullscreenDefaultIcon", component: FullscreenDefaultIcon },
  { name: "FullscreenExitIcon", component: FullscreenExitIcon },
  { name: "HamburguerIcon", component: HamburguerIcon },
  { name: "LeitoIcon", component: LeitoIcon },
  { name: "ListBulletedIcon", component: ListBulletedIcon },
  { name: "PacienteIcon", component: PacienteIcon },
  { name: "PainelIcon", component: PainelIcon },
  { name: "PillIcon", component: PillIcon },
  { name: "PlanoCuidadoIcon", component: PlanoCuidadoIcon },
  { name: "ProfSaudeIcon", component: ProfSaudeIcon },
  { name: "SearchIcon", component: SearchIcon },
  { name: "UnidadeSaudeIcon", component: UnidadeSaudeIcon },
  { name: "UsuarioIcon", component: UsuarioIcon },
  { name: "DeleteIcon", component: DeleteIcon },
  { name: "EditIcon", component: EditIcon },
  { name: "EditPassword", component: EditPassword },
  { name: "DisableIcon", component: DisableIcon },
  { name: "EnableIcon", component: EnableIcon },
  { name: "ProfileIcon", component: ProfileIcon },
  { name: "NotificationIcon", component: NotificationIcon },
  { name: "InformationIcon", component: InformationIcon },
  { name: "ProcedimentoIcon", component: ProcedimentoIcon },
  { name: "MedicamentoIcon", component: MedicamentoIcon },
  { name: "DietaIcon", component: DietaIcon },
  { name: "CuidadoIcon", component: CuidadoIcon },
  { name: "AuditIcon", component: AuditIcon },
  { name: "ExportIcon", component: ExportIcon },
  { name: "AcolhimentoIcon", component: AcolhimentoIcon },
  { name: "RoleIcon", component: RoleIcon },
  { name: "AnalyticsIcon", component: AnalyticsIcon },
  { name: "CalendarAsc", component: CalendarAsc },
  { name: "CalendarDesc", component: CalendarDesc },
  { name: "ThemeIcon", component: ThemeIcon },
  { name: "ParamsIcon", component: ParamsIcon },
  { name: "NaturezaIcon", component: NaturezaIcon },
  { name: "NotificacaoEventoIcon", component: NotificacaoEventoIcon },
  { name: "SpreadSheetIcon", component: SpreadSheetIcon },
  { name: "DownloadIcon", component: DownloadIcon },
  { name: "SegmentationIcon", component: SegmentationIcon },
  { name: "OpenInNewTabIcon", component: OpenInNewTabIcon },
  { name: "EmailIcon", component: EmailIcon },
  { name: "ApiIcon", component: ApiIcon },
  { name: "PlusIcon", component: PlusIcon },
  { name: "TeamsIcon", component: TeamsIcon },
  { name: "SickIcon", component: SickIcon },
  { name: "AnalyzeIcon", component: AnalyzeIcon },
  { name: "ClinicIcon", component: ClinicIcon },
  { name: "ClockIcon", component: ClockIcon },
  { name: "ConnectedPeopleIcon", component: ConnectedPeopleIcon },
  { name: "ControlPanelIcon", component: ControlPanelIcon },
  { name: "DashboardIcon", component: DashboardIcon },
  { name: "DoctorFemaleIcon", component: DoctorFemaleIcon },
  { name: "DoctorMaleIcon", component: DoctorMaleIcon },
  { name: "HospitalBedIcon", component: HospitalBedIcon },
  { name: "HospitalIcon", component: HospitalIcon },
  { name: "HospitalRoomIcon", component: HospitalRoomIcon },
  { name: "MaleFemaleUserGroupIcon", component: MaleFemaleUserGroupIcon },
  { name: "MemberIcon", component: MemberIcon },
  { name: "OldWomanIcon", component: OldWomanIcon },
  { name: "PeopleIcon", component: PeopleIcon },
  { name: "PlannerIcon", component: PlannerIcon },
  { name: "ScheduleIcon", component: ScheduleIcon },
  { name: "SeniorCitizenIcon", component: SeniorCitizenIcon },
  { name: "TearOffCalendarIcon", component: TearOffCalendarIcon },
  { name: "UserGroupsIcon", component: UserGroupsIcon },
  { name: "UserMaleIcon", component: UserMaleIcon },
  { name: "ThreePeopleIcon", component: ThreePeopleIcon },
  { name: "FatherIcon", component: FatherIcon },
  { name: "EnfermeiraIcon", component: EnfermeiraIcon },
  { name: "TelessaudeIcon", component: TelessaudeIcon },
  { name: "SoliciTelessaudeIcon", component: SoliciTelessaudeIcon },
];
